import React from 'react'
import { Box } from '@mui/material'
import { Drawer, Loader } from 'packages/eid-ui'
import ItemHeader from '../ItemHeader'
import { isNilOrEmpty, useIsSmallScreen } from 'packages/core'
import ItemsDetailsMobileWrapper from 'components/ItemsDetailsMobileWrapper'
import BusinessRoleDetails from './BusinessRoleDetails'
import { useBusinessRole } from 'hooks'
import { catalogDetailsDrawerExplainProps } from '../catalogDetailsDrawerExplain'

const BusinessRoleDrawer = ({ id, toggleDrawer, attributes }) => {
    const isSmallScreen = useIsSmallScreen()

    const { data: businessRole } = useBusinessRole(id)

    return isSmallScreen ? (
        <ItemsDetailsMobileWrapper toggleDrawer={toggleDrawer}>
            <Box {...catalogDetailsDrawerExplainProps('business role')}>
                <ItemHeader title={businessRole?.friendlyName} />
                {!businessRole && <Loader />}
                {businessRole && (
                    <BusinessRoleDetails
                        businessRole={businessRole}
                        toggleDrawer={toggleDrawer}
                        attributes={attributes}
                    />
                )}
            </Box>
        </ItemsDetailsMobileWrapper>
    ) : (
        <Drawer
            width="clamp(67%, 1007px, 90%)"
            open={!isNilOrEmpty(id)}
            toggleDrawer={toggleDrawer}
            stickyHeader
            closeOnOutsideClick
            header={<ItemHeader title={businessRole?.friendlyName} />}
        >
            <Box {...catalogDetailsDrawerExplainProps('business role')}>
                {!businessRole && <Loader />}
                {businessRole && (
                    <BusinessRoleDetails
                        businessRole={businessRole}
                        toggleDrawer={toggleDrawer}
                    />
                )}
            </Box>
        </Drawer>
    )
}

export default BusinessRoleDrawer
